import ImageUploadedModalView from './ImageUploadedModalView';

export default ImageUploadedModalView;
